import { TwModal, Text, Button, Icon, Dialog } from '@ui-component-library';
import Cookies from 'js-cookie';
import React from 'react';
import VBSearchInput from '@vb-js-commons/new/vbSearchInput';

class MediaSelector extends React.Component{
    constructor(props){
        super(props);

        this.state = {
            showMedia: false,
            showImageSize: false,
            selectedImage: null,
            files: [],
            pages: 1,
            page_nr: 1,
            image_search:'',
            type: this.props.type ? this.props.type : 'img',
            default_src: this.props.defaultProps
        }
    }

    componentDidMount(){
        this.getFiles();
    }

    getFiles(){
        fetch(`/cms-api/cmsfile/?pagenr=${this.state.page_nr}&search=${this.state.image_search}&type=${this.state.type}`).then(resp => resp.json()).then((json) => {
            this.setState({files:json.files, pages:json.pages})
        })
    }

    checkFileSize(files) {
        if (files.length > 0) {
            /* Todo: possible to upload several files? */
            console.log(files[0].size);
            if (files[0].size > 1000000) {
                this.setState({ showImageSize: true, selectedImage: files[0] })
            } else {
                this.uploadFile(files[0]);
            }
        } else {
            console.log('No file')
        }
    }
    uploadFile(file){
        const formData = new FormData();
        formData.append("file", file);
        fetch(
            "/cms-api/cmsfile/", {
                method: "POST",
                headers: {
                    'X-CSRFToken': Cookies.get('csrftoken')
                },
                body:formData
            }
        ).then(resp => resp.json()).then((json) => {
            this.state.files.push(json.file_url);
            this.setState({files:this.state.files});
        })
    }
    render(){
        return (
        <>
            <Dialog isOpen={this.state.showImageSize}>
                <Dialog.Header>    
                    <Text variant="text-2xl/leading-normal/medium">{`Large image detected (${this.state.selectedImage ? Number(this.state.selectedImage.size / 1000000).toFixed(2): 'X'} MB)`}</Text>
                    <Button variant="tertiary" size="icon" onClick={() => this.setState({ showImageSize: false })}>
                        <Icon name="CrossSimple" size="large" />
                    </Button>     
                </Dialog.Header>
                <Dialog.Content >
                    <Text variant="text-base/leading-normal/medium" className="text-charcoal-500">This image will be automatically resized (max 1920x1080) and converted to WebP file format on upload. Continue?</Text>
                </Dialog.Content>
                <Dialog.Footer> 
                    <Button variant="secondary" onClick={ () => {this.setState({ showImageSize: false, showMedia: false })}}>Close</Button>
                    <Button variant="primary" onClick={ () => {this.setState({ showImageSize: false }, () => {this.uploadFile(this.state.selectedImage)})}}>Continue</Button>
                </Dialog.Footer>
            </Dialog>
            <TwModal isOpen={this.state.showMedia}>
                <TwModal.Header>         
                    <div className="w-2/3">
                        <Text variant="text-xl/leading-normal/medium" className="mb-0">{`Click the ${this.state.type == "img" ? "image": "icon"} you want to use:`}</Text>
                    </div>
                    <div className="flex gap-2 items-center">
                        <input type="file" name="file" id="file" className="hidden" onChange={(e) => {this.checkFileSize(e.target.files)}} />
                        <label htmlFor='file' className='bg-spring-yellow-600 p-2 rounded-md cursor-pointer'><Text variant="text-xs/leading-normal/medium" className="neutral-pebble whitespace-nowrap">Upload file</Text></label>
                        <Button variant="tertiary" size="icon" onClick={() => this.setState({ showMedia: false })}>
                            <Icon name="CrossSimple" size="large" className="fill-neutral-pebble" />
                        </Button>
                    </div>
                </TwModal.Header>
                <TwModal.Content className="neutral-pebble">
                    {((this.state.files).length > 0 || this.state.image_search != '') && <div className='mb-2 flex justify-end'>
                        <div className='w-full md:w-1/3'>
                            <VBSearchInput
                                inputStyle={{minHeight: 0, borderStyle:"groove"}} 
                                ref={this.search_image}
                                placeholder={`Search for ${this.state.type == "img" ? "image": "icon"}`}
                                onChange={(val) => { this.setState({image_search:val},()=>{this.getFiles()})}}
                                />
                        </div>
                    </div>}
                    
                    <div className='flex flex-wrap'>
                        {this.state.files.map((itm) => {
                            let fileNameArr = itm.split('/')
                            let fileName = fileNameArr[fileNameArr.length-1]
                            return <div className="w-1/2 lg:w-1/6">
                                <div className='mb-2'>
                                <div className="border border-neutral-pebble rounded p-2" onClick={() => { this.props.onChange(itm); this.setState({ showMedia: false }) }}>
                                <img className="max-w-full " style={{height:"100px", objectFit:"contain"}} src={itm} />
                                <div className="fs-8 neutral-pebble">{fileName.length > 20 ? `${fileName.slice(0,17)}...${fileName.slice(-3)}` : fileName}</div>
                                </div>
                                </div>
                            </div>;
                        })}
                    </div>
                    <div className="flex justify-end gap-2">
                        {this.state.page_nr > 1 ? <button className="n-btn btn-sm btn-forest-green" onClick={() => {
                            this.setState({ page_nr: this.state.page_nr - 1 }, () => {
                                this.getFiles()
                            });
                        }}>Previous Page</button> : ''}
                        {this.state.page_nr != this.state.pages ? <button className="n-btn btn-sm btn-outline btn-charcoal" onClick={() => {
                            this.setState({ page_nr: this.state.page_nr + 1 }, () => {
                                this.getFiles()
                            });
                        }}>Next Page</button> : ''}
                    </div>
        
                    <div className="neutral-pebble">{this.state.page_nr} / {this.state.pages}</div>
                </TwModal.Content>
            </TwModal>
            <div className="w-full fs-6 font-bold mb-2">
            {this.props.label ? this.props.label : (this.props.name ? this.props.name : '')}
            </div>
            <button className="_Button_1brfa_1 _Button--secondary_1brfa_53 _Button--medium_1brfa_22" onClick={() => {this.getFiles();this.setState({showMedia: true})}}>{`Select ${this.state.type == "img" ? "image": "icon"}`}</button>
            
        </>)
    }
}

export default MediaSelector;